// Module
var code = "<div class=\"availabilities-empty-slot\"> <div class=\"availabilities-empty-slot-dash\"></div> </div>";
// Exports
module.exports = code;